/**
 * Maps a Google Places result to form location fields.
 * Use in DateLocationStep when Places Autocomplete is wired.
 */
export const applyGooglePlaceToForm = (place) => {
  if (!place) {
    return { location: '', latitude: '', longitude: '' };
  }

  const location = place.formatted_address ?? place.name ?? '';
  const coords = place.geometry?.location;
  const lat = typeof coords?.lat === 'function' ? coords.lat() : coords?.lat;
  const lng = typeof coords?.lng === 'function' ? coords.lng() : coords?.lng;

  return {
    location,
    latitude: lat != null ? String(lat) : '',
    longitude: lng != null ? String(lng) : '',
  };
};
